import {useApp} from 'AppContext'
import {Block} from 'blocks/block'
import {Theme} from 'layout/theme'
import {DPTextblockBlock} from 'types/DPTypes'
import {fromModule} from 'util/styler/Styler'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import css from './textblock.module.scss'

const styles = fromModule(css)

export const Textblock: React.FC<DPTextblockBlock> = (data) => {
	const {text, display_grey, display_dark} = data
	const {node} = useApp()
	const id = useIDFromAnchorBlock(data)
	if (!text) return null

	return (
		<Block
			type="textblock"
			className={styles.textblock
				.mod(node?._type)
				.mod({dark: display_dark})
				.mod({grey: display_grey})()}
			anchorID={id}
		>
			<Theme.Container>
				<div className={styles.textblock.content()}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			</Theme.Container>
		</Block>
	)
}
